<template>
    <div class="modal-container">
        <div class="modal-header">
            <h4 class="modal-title">Add Item</h4>
        </div>
        <div class="modal-body">
            <form-wrapper :validator="$v" class="form-wrapper">
                <div class="item-barcode">
                    <form-group name="barcode" label="Barcode">
                        <md-input v-model="barcode" v-focus />
                    </form-group>
                </div>
                <div class="item-description">
                    <form-group name="description" label="Description">
                        <md-input v-model="description" />
                    </form-group>
                </div>
                <div class="item-description">
                    <form-group name="sku" label="SKU">
                        <md-input v-model="sku" />
                    </form-group>
                </div>
                <div class="item-description">
                    <form-group name="productReference" label="Product Reference">
                        <md-input v-model="productReference" />
                    </form-group>
                </div>
                <div class="item-description">
                    <form-group name="installationTime" label="Installation Time In Minutes">
                        <md-input v-model="installationTimeInMinutes" />
                    </form-group>
                </div>
                <div v-if="loadFieldList !== null">
                    <load-inputs
                        v-for="(load, index) in loadFieldList"
                        :key="index"
                        :load-definition="load"
                        :initial-value="loadValues"
                        @changed="handleLoadChanged"
                    />
                </div>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <md-button class="md-primary dialog-button" @click="addItem">
                Save
            </md-button>
            <md-button class="md-default dialog-button" @click.stop="$modal.hide">
                Cancel
            </md-button>
        </div>
    </div>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import { handleRequests, showErrorMessage } from '@/helpers';
import { LoadInputs } from '@/components';

export default {
    name: 'AddItemModal',
    mixins: [GeneralMixin],
    components: { LoadInputs },
    props: {
        resolve: {
            type: Function,
            default: () => {}
        }
    },
    validations: {
        barcode: {
            required
        }
    },
    data() {
        return {
            barcode: null,
            description: null,
            sku: null,
            productReference: null,
            installationTimeInMinutes: null,
            loadFieldList: [],
            loadValues: {}
        };
    },
    computed: {
        ...mapGetters({
            user: 'user/user'
        })
    },
    mounted() {
        this.loadFieldList = [];
        if (this.user.vehicleCapacityUnitsConfiguration && this.user.vehicleCapacityUnitsConfiguration.length > 0) {
            this.loadFieldList = this.user.vehicleCapacityUnitsConfiguration.filter((x) => x.type !== 'quantity');
        }
    },
    methods: {
        async addItem() {
            if (this.$v.$invalid) {
                showErrorMessage(this, 'Barcode is required');
                return;
            }

            this.$_handleLoaderState(true, 'SAVING...');
            const payload = {
                method: 'post',
                data: {
                    barcode: this.barcode,
                    description: this.description,
                    sku: this.sku,
                    productReference: this.productReference,
                    installationTimeInMinutes: this.installationTimeInMinutes,
                    load: this.loadValues
                }
            };
            try {
                const api = `/api/items/`;
                await handleRequests(api, payload);

                this.$notify({
                    message: `Item added!`,
                    type: 'success'
                });
                this.$v.$reset();

                this.resolve(payload.data);
            } catch (e) {
                const message = 'Cannot add item.';
                showErrorMessage(this, message);
                this.resolve(null);
            }
            this.$_handleLoaderState(false);
        },
        handleLoadChanged({ name, value }) {
            this.loadValues[name] = value;
        }
    }
};
</script>
<style lang="scss" scoped>
.modal-container {
    max-width: 600px !important;
}
</style>
